// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3IvVo","title":"FrontImage_title__32Li-"};